module.exports = __webpack_public_path__ + "static/img/about050.c151dcb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about050.png
// module id = vL/B
// module chunks = 1